import { Component,OnInit } from '@angular/core';
import { HeaderComponent } from '../header/header.component';
import { FooterComponent } from '../footer/footer.component';
import { ApidataService } from '../apidata.service';
import swal from 'sweetalert2';
import { Router, Params, ActivatedRoute } from '@angular/router';
import { NavigationEnd, RouterLink } from '@angular/router';
import { RouterModule } from '@angular/router';
import { filter } from 'rxjs/operators';
import { CommonModule } from '@angular/common';
import { environment, GINConstants } from '../../environments/environments';
@Component({
  selector: 'app-success',
  standalone: true,
  imports: [HeaderComponent, FooterComponent, RouterModule, CommonModule ],
  templateUrl: './success.component.html',
  styleUrl: './success.component.css',
  providers: [ApidataService]
})
export class SuccessComponent implements OnInit {
  public docTitle2 = '';
  public profile_id = '';
  doc_id;
  notlogin : boolean = false;
  constructor(private router: Router, private apiservice: ApidataService,) {
    this.router.events
    .pipe(filter(event => event instanceof NavigationEnd))
    .subscribe(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });

   }

  ngOnInit(): void {
    this.profile_id = localStorage.getItem('profile_id');
    if(this.profile_id === '1' || this.profile_id === null){
      this.notlogin = false;
    }
    else{
      this.notlogin = true;
    }
  }

  public gotoeditor(type) {
    let data2 = JSON.stringify({ homeText: '', profile_id: this.profile_id });
    let url = environment.API_URL+'/api/getNewDocIDForGuestByContents';
    this.apiservice.postResources(data2, url).subscribe((data) => {
      let receivedData = data;
      this.doc_id = receivedData['new_doc_id'];
      // this.router.navigate(['/document/', this.doc_id]);
      this.router.navigate(['/grammar-check'], { queryParams: { doc: this.doc_id } });
    });
  }
gotosignin(){
  this.router.navigate(['/signin'])
}
}
